<template>
  <div v-if="show" class="fullscreen-text-overlay" @click="handleClose">
    <div class="fullscreen-text-content">
      <div class="text-display">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, nextTick } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:show', 'close'])

// 处理关闭
const handleClose = () => {
  emit('update:show', false)
  emit('close')
}

// 监听显示状态，处理页面滚动
watch(() => props.show, (newShow) => {
  nextTick(() => {
    if (newShow) {
      // 显示时禁止页面滚动
      document.body.style.overflow = 'hidden'
    } else {
      // 隐藏时恢复页面滚动
      document.body.style.overflow = ''
    }
  })
})
</script>

<style lang="scss" scoped>
.fullscreen-text-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  box-sizing: border-box;

  // 进入动画
  animation: fadeIn 0.3s ease-out;
}

.fullscreen-text-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.text-display {
  font-size: 32px;
  line-height: 1.7;
  /* padding: 24px; */
  color: #333;
  width: 100%;
}

// 进入动画
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 移动端适配
@media (max-width: 480px) {
  .fullscreen-text-overlay {
    padding: 16px;
  }

}





// 安全区域适配（iPhone X系列）
@supports (padding: max(0px)) {
  .fullscreen-text-overlay {
    padding-top: max(20px, env(safe-area-inset-top));
    padding-bottom: max(20px, env(safe-area-inset-bottom));
    padding-left: max(20px, env(safe-area-inset-left));
    padding-right: max(20px, env(safe-area-inset-right));
  }
}
</style>